import React from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from "@shared/store/dialog.duck";
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { ChooseOfficeControls } from "../components/ChooseOfficeControls";

export default function ChangeOfficeDialog() {
  const dispatch = useDispatch();
  const close = () => {
    dispatch(closeDialog());
  }

  return (
    <Dialog isOpen={true} onClose={() => close()}>
      <DialogHeader title={'button.change-office'} />
      <ChooseOfficeControls onSelect={close} />
    </Dialog>
  )
}
